const t = {
  name: "DebitCard",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 14H12V16H4V14Z" fill="currentColor"/>
<path d="M20 8L14 8V10L20 10V8Z" fill="currentColor"/>
<path d="M0 7C0 5.34772 1.34772 4 3 4H21C22.6523 4 24 5.34772 24 7V17C24 18.6523 22.6523 20 21 20H3C1.34772 20 0 18.6523 0 17V7ZM3 6C2.45228 6 2 6.45228 2 7V17C2 17.5477 2.45228 18 3 18H21C21.5477 18 22 17.5477 22 17V7C22 6.45228 21.5477 6 21 6H3Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as DebitCard
};
